import { render, staticRenderFns } from "./KzsViewAlgoSettings.vue?vue&type=template&id=a64c8548"
import script from "./KzsViewAlgoSettings.vue?vue&type=script&lang=js"
export * from "./KzsViewAlgoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports